'use strict';
window.LongvadonAdapterGuidePicker=(()=>{
 const $=s=>document.querySelector(s);
 const escape=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
 const visuals=()=>LongvadonWatchHelp;
 let models=[],selected,category='All',term='',onChange,session=0;
 const active=()=>$('#help')?.open&&$('#help').classList.contains('adapter-guide');
 // The finder has distinct SE generations; existing photo sources share one SE group.
 const watchId=m=>m.family==='Ultra'?`ultra-${m.generation}-${m.finish==='Black Titanium'?'black':'natural'}`:m.family==='SE'?`se-${m.group.toLowerCase()}`:`series-${m.generation}-${m.group.toLowerCase()}`;
 const previewId=m=>m.family==='Ultra'?m.id:`${m.family.toLowerCase()}-${m.generation}`;
 const title=m=>`${visuals().modelName(m)}${m.family==='Ultra'?' · '+m.finish:''}`;
 function markup(){return `<div class="adapter-watch-picker">
  <div class="adapter-watch-heading">
   <div id="adapter-preview-watch" class="adapter-preview-watch" aria-live="polite"><span>Loading watch…</span></div>
   <button id="adapter-watch-trigger" class="adapter-watch-trigger" role="combobox" aria-label="Change preview watch" aria-haspopup="listbox" aria-controls="adapter-watch-options" aria-expanded="false" disabled>Change watch <span aria-hidden="true">⌄</span></button>
  </div>
  <div id="adapter-watch-dropdown" class="adapter-watch-dropdown" hidden>
   <label for="adapter-watch-search">Find your model</label><input id="adapter-watch-search" type="search" placeholder="Search series or color" autocomplete="off">
   <div class="watch-model-categories" role="group" aria-label="Preview watch family">${['All','Series','SE','Ultra'].map(v=>`<button data-adapter-category="${v}" aria-pressed="${v==='All'}">${v}</button>`).join('')}</div>
   <div id="adapter-watch-options" role="listbox" aria-label="Preview Apple Watch models"></div>
  </div>
 </div>`}
 async function init(initialWatchId,change){
  const current=++session;selected=null;category='All';term='';onChange=change;
  try{
   const allModels=(await visuals().loadData()).models;
   if(current!==session||!active())return;
   // Size affects the photo-source lookup, but is not a separate visual preview choice.
   const initial=allModels.find(m=>watchId(m)===initialWatchId),preferredGroup=initial?.group==='Small'?'Small':'Large',unique=new Map();
   for(const m of allModels)if(!unique.has(previewId(m))||m.group===preferredGroup)unique.set(previewId(m),{...m,id:previewId(m)});
   models=[...unique.values()];
   selected=models.find(m=>watchId(m)===initialWatchId)||models[0];
   $('#adapter-watch-trigger').disabled=false;renderSelection();renderOptions();onChange(selected);
  }catch{
   if(current!==session||!active())return;
   $('#adapter-preview-watch').textContent='Couldn’t load watch models.';
   const trigger=$('#adapter-watch-trigger');trigger.disabled=false;trigger.textContent='Try again';
   trigger.onclick=()=>{trigger.onclick=null;init(initialWatchId,change)};
  }
 }
 function renderSelection(){
  $('#adapter-preview-watch').dataset.model=selected.id;
  $('#adapter-preview-watch').innerHTML=`${visuals().thumbnail(selected,{loading:'eager'})}<div><span class="adapter-preview-caption">Previewing</span><h3>${escape(title(selected))}</h3></div>`;
 }
 function renderOptions(){
  const normalize=s=>s.toLowerCase().replace(/[^a-z0-9]/g,'');
  const terms=term.toLowerCase().split(/\s+/).filter(Boolean);
  const matches=models.filter(m=>(category==='All'||m.family===category)&&terms.every(t=>['series','se','ultra'].includes(t)?m.family.toLowerCase()===t:/^\d+$/.test(t)?m.generation===Number(t):normalize(`${visuals().modelName(m)} ${m.name} ${m.finish}`).includes(normalize(t))));
  $('#adapter-watch-options').innerHTML=['Series','SE','Ultra'].map(family=>{
   const options=matches.filter(m=>m.family===family);if(!options.length)return '';
   return `<div role="group" aria-labelledby="adapter-family-${family}"><div id="adapter-family-${family}" class="watch-model-group-title">Apple Watch ${family}</div>${options.map(m=>`<button role="option" aria-selected="${m.id===selected.id}" tabindex="-1" data-adapter-model="${m.id}">${visuals().thumbnail(m,{loading:'eager'})}<span class="watch-model-option-copy"><strong>${escape(visuals().modelName(m))}</strong>${m.finish?`<small>${escape(m.finish)}</small>`:''}</span><span class="adapter-watch-check" aria-hidden="true">${m.id===selected.id?'✓':''}</span></button>`).join('')}</div>`;
  }).join('')||'<p class="adapter-watch-empty" role="status">No models match. Try another series or color.</p>';
  $('#adapter-watch-options').scrollTop=0;
 }
 function toggle(open,focus=true){
  $('#adapter-watch-dropdown').hidden=!open;$('#adapter-watch-trigger').setAttribute('aria-expanded',String(open));
  // Opening leaves the focus on Change watch: the search field takes it only when tapped, so a phone does not open its
  // keyboard (Robin, October 22). Closing brings it back to Change watch.
  if(focus&&!open)$('#adapter-watch-trigger').focus({preventScroll:true});
 }
 document.addEventListener('click',e=>{
  if(!active()||!selected)return;
  const b=e.target.closest('button');
  if(b?.id==='adapter-watch-trigger'){toggle($('#adapter-watch-dropdown').hidden)}
  else if(b?.dataset.adapterCategory){
   category=b.dataset.adapterCategory;
   for(const c of document.querySelectorAll('[data-adapter-category]'))c.setAttribute('aria-pressed',String(c===b));
   renderOptions();
  }else if(b?.dataset.adapterModel){
   selected=models.find(m=>m.id===b.dataset.adapterModel);renderSelection();renderOptions();toggle(false);onChange(selected);
   $('#help').scrollTop=0;
  }else if(!e.target.closest('.adapter-watch-picker'))toggle(false,false);
 });
 document.addEventListener('input',e=>{if(active()&&e.target.id==='adapter-watch-search'){term=e.target.value;renderOptions()}});
 document.addEventListener('keydown',e=>{
  if(!active()||!selected)return;
  const trigger=$('#adapter-watch-trigger'),dropdown=$('#adapter-watch-dropdown');
  const options=[...$('#adapter-watch-options').querySelectorAll('[role=option]')];
  if(e.target===trigger&&['ArrowDown','ArrowUp'].includes(e.key)){
   e.preventDefault();toggle(true,false);(options.find(o=>o.getAttribute('aria-selected')==='true')||options[e.key==='ArrowUp'?options.length-1:0])?.focus();return;
  }
  if(dropdown.hidden)return;
  if(e.key==='Escape'){e.preventDefault();e.stopPropagation();toggle(false);return}
  if(!dropdown.contains(e.target))return;
  const index=options.indexOf(e.target);
  if(['ArrowDown','ArrowUp','Home','End'].includes(e.key)&&(index>=0||e.target.id==='adapter-watch-search')){
   if(e.target.id==='adapter-watch-search'&&['Home','End'].includes(e.key))return;
   e.preventDefault();const next=e.key==='Home'?0:e.key==='End'?options.length-1:e.key==='ArrowDown'?Math.min(index+1,options.length-1):index<0?options.length-1:Math.max(0,index-1);options[next]?.focus();
  }
  if(e.key==='Tab')toggle(false,false);
 });
 return {markup,init,watchId};
})();
